/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import Link from "antd/es/typography/Link"

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid pb-20'>
          {/* begin::Wrapper */}
          {/* <Row> */}
          <img src={toAbsoluteUrl('/media/logos/fpt.svg')} className='mx-auto mt-10' style={{ maxWidth: 120, width: '50%' }} alt='' />
          <span className='fs-5 fw-bold text-gray-600 pb-2'>FPT Healthcare Platform</span>
          {/* </Row> */}
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        <div className='d-flex flex-center flex-wrap px-5'>
          {/* begin::Links */}
          <div className='d-flex fw-semibold text-primary fs-base'>
            <Link href='https://metadoc.vn/2022/12/14/dieu-khoan-chinh-sach/' className='px-5' target='_blank'>
              Điều khoản sử dụng
            </Link>
            <Link href='https://metadoc.vn/contact-us/' className='px-5' target='_blank'>
              Liên hệ
            </Link>
          </div>
          {/* end::Links */}
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { AuthLayout }
